import React from "react";

export const HeartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none">
      <path
        d="M15.696 1C13.652 1 11.887 2.197 11 3.943C10.113 2.197 8.348 1 6.304 1C3.374 1 1 3.457 1 6.481C1 9.505 2.817 12.277 5.165 14.554C7.513 16.831 11 19 11 19C11 19 14.374 16.867 16.835 14.554C19.46 12.088 21 9.514 21 6.481C21 3.448 18.626 1 15.696 1Z"
        stroke="#FF2600"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
